// Mock data for Studerus Electric Inc.

export const reviews = [
  {
    id: 1,
    name: "Sarah Johnson",
    rating: 5,
    text: "Professional, trustworthy, knowledgeable, prompt, and reliable. Fair pricing and high-quality workmanship. Highly recommend Studerus Electric!",
    date: "2024-11"
  },
  {
    id: 2,
    name: "Michael Peterson",
    rating: 5,
    text: "Efficiency and superior quality of work. They take no shortcuts and provide great value for the cost. Very happy with their service.",
    date: "2024-10"
  },
  {
    id: 3,
    name: "Jennifer Matthews",
    rating: 5,
    text: "Easy scheduling and respectful manner. The team was considerate of our time and property. Excellent customer service throughout the entire process.",
    date: "2024-09"
  },
  {
    id: 4,
    name: "David Thompson",
    rating: 5,
    text: "Outstanding work ethic and professionalism. Studerus Electric handled our commercial project with expertise and efficiency. Would definitely use them again.",
    date: "2024-08"
  },
  {
    id: 5,
    name: "Lisa Anderson",
    rating: 5,
    text: "From start to finish, the experience was excellent. Their electricians are fully licensed and the company is fully insured. Peace of mind guaranteed!",
    date: "2024-07"
  }
];

export const services = [
  {
    id: 1,
    title: "Residential Electrical",
    description: "Complete electrical services for your home including installations, repairs, and upgrades.",
    icon: "home",
    link: "/services/residential"
  },
  {
    id: 2,
    title: "Commercial Electrical",
    description: "Professional electrical solutions for businesses and commercial properties.",
    icon: "building",
    link: "/services/commercial"
  },
  {
    id: 3,
    title: "Fire Alarm Systems",
    description: "Commercial fire alarm installation, verification, and testing services.",
    icon: "bell",
    link: "/services/fire-alarm"
  },
  {
    id: 4,
    title: "Panel Upgrades",
    description: "Electrical panel upgrades and circuit breaker installations to meet modern power demands.",
    icon: "settings",
    link: "/services/panel-upgrades"
  },
  {
    id: 5,
    title: "Solar Installation",
    description: "Professional solar panel installation and electrical integration for clean energy.",
    icon: "sun",
    link: "/services/solar"
  },
  {
    id: 6,
    title: "EV Charger Installation",
    description: "Level 2 electric vehicle charging station installation for homes and businesses.",
    icon: "zap",
    link: "/services/ev-charging"
  },
  {
    id: 7,
    title: "Generator Installation",
    description: "Expert installation of standby generators for reliable backup power.",
    icon: "battery",
    link: "/services/generator-installation"
  },
  {
    id: 8,
    title: "Thermal Scanning",
    description: "Advanced infrared thermographic inspections to detect electrical issues.",
    icon: "thermometer",
    link: "/services/thermal-scanning"
  },
  {
    id: 9,
    title: "Highrise Turnovers",
    description: "Specialized electrical services for apartment renovations and highrise buildings.",
    icon: "building-2",
    link: "/services/highrise-turnovers"
  }
];

export const serviceAreas = [
  "London",
  "Kingston",
  "Windsor",
  "Chatham",
  "Sarnia",
  "Kitchener",
  "St Thomas",
  "Ingersoll",
  "Woodstock"
];

export const galleryImages = [
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_se-power-solutions/artifacts/1xa5vtj8_20190123_151159.jpg",
    alt: "Studerus Electric service van"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_se-power-solutions/artifacts/vb0h1w9f_20201215_233319.jpg",
    alt: "Commercial lighting installation at night"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_se-power-solutions/artifacts/ogisgzx9_20180731_074943.jpg",
    alt: "Electrical panel and meter installation"
  },
  {
    id: 4,
    url: "https://customer-assets.emergentagent.com/job_se-power-solutions/artifacts/5z40ef0j_20181219_130828%20-%20Copy.jpg",
    alt: "Commercial office lighting installation"
  },
  {
    id: 5,
    url: "https://customer-assets.emergentagent.com/job_se-power-solutions/artifacts/ocfy46xz_20200225_101603.jpg",
    alt: "Electrical panel rough-in construction"
  },
  {
    id: 6,
    url: "https://customer-assets.emergentagent.com/job_se-power-solutions/artifacts/1zsd9720_20201202_170749.jpg",
    alt: "Commercial storefront electrical signage"
  },
  {
    id: 7,
    url: "https://customer-assets.emergentagent.com/job_se-power-solutions/artifacts/tp7kdskv_20200702_161919%20-%20Copy.jpg",
    alt: "Residential chandelier installation"
  },
  {
    id: 8,
    url: "https://customer-assets.emergentagent.com/job_se-power-solutions/artifacts/5alt3po6_20190317_123801.jpg",
    alt: "Outdoor electrical panel and meter"
  },
  {
    id: 9,
    url: "https://customer-assets.emergentagent.com/job_se-power-solutions/artifacts/bj64oie2_20190810_184141.jpg",
    alt: "Commercial warehouse lighting installation"
  },
  {
    id: 10,
    url: "https://customer-assets.emergentagent.com/job_se-power-solutions/artifacts/vg473v7n_20200218_100242.jpg",
    alt: "Residential electrical rough-in wiring"
  },
  {
    id: 11,
    url: "https://customer-assets.emergentagent.com/job_se-power-solutions/artifacts/qngfihic_20200501_155118.jpg",
    alt: "Construction electrical panel installation"
  },
  {
    id: 12,
    url: "https://customer-assets.emergentagent.com/job_se-power-solutions/artifacts/uegd3ij8_20220624_114953.jpg",
    alt: "Retail store lighting installation"
  },
  {
    id: 13,
    url: "https://customer-assets.emergentagent.com/job_se-power-solutions/artifacts/n20oiwxs_20201013_122607.jpg",
    alt: "Office commercial lighting project"
  },
  {
    id: 14,
    url: "https://customer-assets.emergentagent.com/job_se-power-solutions/artifacts/u36facvm_20210121_155234.jpg",
    alt: "Warehouse ceiling electrical work"
  },
  {
    id: 15,
    url: "https://customer-assets.emergentagent.com/job_se-power-solutions/artifacts/l6ggmhnz_20211201_000254.jpg",
    alt: "Residential construction wiring"
  },
  {
    id: 16,
    url: "https://customer-assets.emergentagent.com/job_se-power-solutions/artifacts/uhd09z3p_20220624_114932.jpg",
    alt: "Commercial space lighting upgrade"
  },
  {
    id: 17,
    url: "https://customer-assets.emergentagent.com/job_se-power-solutions/artifacts/6yyatgm1_20220624_115232.jpg",
    alt: "Modern office lighting installation"
  },
  {
    id: 18,
    url: "https://customer-assets.emergentagent.com/job_se-power-solutions/artifacts/vdxv0mjk_20220624_114953.jpg",
    alt: "Commercial ceiling lighting project"
  },
  {
    id: 19,
    url: "https://customer-assets.emergentagent.com/job_se-power-solutions/artifacts/x3gr91n4_20220624_115039.jpg",
    alt: "Office space electrical upgrade"
  },
  {
    id: 20,
    url: "https://customer-assets.emergentagent.com/job_se-power-solutions/artifacts/yxd63mv8_20220624_115055.jpg",
    alt: "Contemporary office lighting design"
  },
  {
    id: 21,
    url: "https://customer-assets.emergentagent.com/job_se-power-solutions/artifacts/w3bg72xm_20220624_115203.jpg",
    alt: "Professional office lighting installation"
  },
  {
    id: 22,
    url: "https://customer-assets.emergentagent.com/job_se-power-solutions/artifacts/6gqzylrw_20220923_145546.jpg",
    alt: "Residential backyard electrical lighting"
  },
  {
    id: 23,
    url: "https://customer-assets.emergentagent.com/job_se-power-solutions/artifacts/3vij9m9b_20220923_145607.jpg",
    alt: "Outdoor pool and patio lighting installation"
  },
  {
    id: 24,
    url: "https://customer-assets.emergentagent.com/job_se-power-solutions/artifacts/6b14u4gg_20220810_211804.jpg",
    alt: "Residential pool LED lighting project"
  },
  {
    id: 25,
    url: "https://customer-assets.emergentagent.com/job_se-power-solutions/artifacts/vit282x5_20220810_213033.jpg",
    alt: "Evening pool lighting installation"
  },
  {
    id: 26,
    url: "https://customer-assets.emergentagent.com/job_se-power-solutions/artifacts/srp11d8i_20220923_144804.jpg",
    alt: "Commercial storefront signage electrical work"
  },
  {
    id: 27,
    url: "https://customer-assets.emergentagent.com/job_se-power-solutions/artifacts/va4mydao_IMG_3896.jpg",
    alt: "Commercial electrical installation"
  },
  {
    id: 28,
    url: "https://customer-assets.emergentagent.com/job_se-power-solutions/artifacts/ky6l1zoh_20221215_093533.jpg",
    alt: "Industrial electrical panel work"
  },
  {
    id: 29,
    url: "https://customer-assets.emergentagent.com/job_se-power-solutions/artifacts/hochomhx_20250529_164523.jpg",
    alt: "Electrical conduit installation"
  },
  {
    id: 30,
    url: "https://customer-assets.emergentagent.com/job_se-power-solutions/artifacts/y3l72jcu_2574550721558767320.jpg",
    alt: "Electrical equipment installation"
  },
  {
    id: 31,
    url: "https://customer-assets.emergentagent.com/job_se-power-solutions/artifacts/onbf1crw_IMG_0746.jpg",
    alt: "Commercial electrical project"
  },
  {
    id: 32,
    url: "https://customer-assets.emergentagent.com/job_next-day-electric/artifacts/ixeapq2i_3251668071124642851%281%29%281%29.jpg",
    alt: "Electrical installation project"
  },
  {
    id: 33,
    url: "https://customer-assets.emergentagent.com/job_next-day-electric/artifacts/wvbz86rk_20251003_140105.jpg",
    alt: "Professional electrical work"
  },
  {
    id: 34,
    url: "https://customer-assets.emergentagent.com/job_next-day-electric/artifacts/bdcyqeyd_1000013527.jpg",
    alt: "Electrical service installation"
  },
  {
    id: 35,
    url: "https://customer-assets.emergentagent.com/job_next-day-electric/artifacts/7e66buzr_1000013528%281%29.jpg",
    alt: "Electrical panel and wiring work"
  },
  {
    id: 36,
    url: "https://customer-assets.emergentagent.com/job_next-day-electric/artifacts/eu00vl6u_831181107506370650%281%29.jpg",
    alt: "Professional electrical installation"
  },
  {
    id: 37,
    url: "https://customer-assets.emergentagent.com/job_next-day-electric/artifacts/gn85c1zx_image000008%281%29%281%29.jpg",
    alt: "Electrical wiring and installation"
  },
  {
    id: 38,
    url: "https://customer-assets.emergentagent.com/job_next-day-electric/artifacts/dtxfypxb_4107921092961023079%281%29.jpg",
    alt: "Commercial electrical project"
  },
  {
    id: 39,
    url: "https://customer-assets.emergentagent.com/job_next-day-electric/artifacts/ikyuwosh_8540788650227651534.jpg",
    alt: "Professional electrical service work"
  }
];

export const generators = [
  {
    id: 1,
    model: "7 kW PowerProtect",
    power: "7 kW",
    features: [
      "Compact size",
      "Fully automatic operation",
      "Runs on LP or Natural Gas",
      "50 A Automatic Transfer Switch included",
      "Space-saving footprint"
    ],
    ideal: "Small homes and essential circuits"
  },
  {
    id: 2,
    model: "13 kW PowerProtect DX",
    power: "13 kW",
    features: [
      "Compact footprint with front exhaust",
      "Quiet weekly test mode",
      "Corrosion-resistant aluminum enclosure",
      "68% better motor starting power",
      "Assembled in USA"
    ],
    ideal: "Medium-sized homes"
  },
  {
    id: 3,
    model: "20 kW PowerProtect",
    power: "20 kW",
    features: [
      "18,000 continuous watts",
      "Dual voltage 120/240V",
      "Auto voltage regulation",
      "Digital control panel with remote alerts",
      "CARB certified"
    ],
    ideal: "Whole house backup power"
  },
  {
    id: 4,
    model: "22 kW PowerProtect",
    power: "22 kW",
    features: [
      "Commercial-grade Vanguard engine",
      "200 Amp ATS with Symphony II Power Management",
      "16-second eco-friendly weekly test",
      "Tool-less access for maintenance",
      "Can install 18 inches from home"
    ],
    ideal: "Large homes with high power demands"
  }
];